import React from 'react'
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";

const PlacesWildlifeRefuges = () => {
    const parks = [
        {
            "NAME": "Bear River National Wildlife Refuge",
            "LAND ADMINISTRATOR": "U.S. Fish and Wildlife Service",
            "Address": "2155 W Forest St, Brigham City, UT 84302, United States",
            "Phone No:": "435-723-5887",
            "Website": "https://www.fws.gov/refuge/bear-river-migratory-bird",
            "Established on": "1928"
        },
        {
            "NAME": "Fish Springs National Wildlife Refuge",
            "LAND ADMINISTRATOR": "U.S. Fish and Wildlife Service",
            "Address": "8454 Auto Tour Rte 010, Dugway, UT 84022, United States",
            "Phone No:": "435-693-3122",
            "Website": "https://www.fws.gov/refuge/fish-springs",
            "Established on": "1959"
        },
        {
            "NAME": "Jones Hole National Fish Hatchery",
            "LAND ADMINISTRATOR": "U.S. Fish and Wildlife Service",
            "Address": "24495 East Jones Hole Hatchery Road, Vernal, UT 84078",
            "Phone No:": "435-789-4481",
            "Website": "https://www.fws.gov/fish-hatchery/jones-hole",
            "Established on": "1968"
        },
        {
            "NAME": "Ouray National Fish Hatchery",
            "LAND ADMINISTRATOR": "U.S. Fish and Wildlife Service",
            "Address": "21000 East Wildlife Refuge Road, Randlett, UT 84063",
            "Phone No:": "435-828-7134",
            "Website": "https://www.fws.gov/fish-hatchery/ouray",
            "Established on": "1996"
        },
        {
            "NAME": "Ouray National Wildlife Refuge",
            "LAND ADMINISTRATOR": "U.S. Fish and Wildlife Service",
            "Address": "HC 69 Box 232, Randlett, UT 84063",
            "Phone No:": "435-545-2522",
            "Website": "https://www.fws.gov/refuge/ouray",
            "Established on": "1960"
        }
    ]
    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
            {/* Landing Section */}
            <LandingSection
                data={{ imageName: "refuge.webp", title: "National Wildlife Refuges" }}
            />

            {/* Main Content */}
            <div className=" mx-auto  py-12 w-full">
                {/* Intro Section */}
                <div className="text-center mb-12">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-900 mb-2">
                        Utah's National Wildlife Refuges
                    </h1>
                    <p className="text-xl text-blue-700">
                        Experience the serenity of Utah’s diverse wildlife habitats
                    </p>
                </div>

                {/* Parks Table */}
                <div className='flex items-center justify-center'>
                    <div className="bg-white rounded-xl  shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
                        <div className="overflow-x-auto">
                            <table className="min-w-full ">
                                <thead className="bg-gradient-to-r from-blue-50 to-blue-100">
                                    <tr>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Name
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Land Administrator
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Contact
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Website
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Established
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {parks.map((park, index) => (
                                        <tr key={index} className="hover:bg-blue-50 transition-colors">
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park.NAME}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park["LAND ADMINISTRATOR"]}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park["Phone No:"]}</div>
                                                <div className="text-sm text-center font-bold text-blue-900">{park.Address}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                <a
                                                    href={park.Website}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-600 font-bold hover:text-blue-800 hover:underline"
                                                >
                                                    Visit Website
                                                </a>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-center font-bold text-blue-900">
                                                {park["Established on"]}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}

export default PlacesWildlifeRefuges
